
import generalMixin from '~/mixins/generalMixin'

import jobCard from '~/components/jobs/job-card'

export default {
  components: {
    jobCard
  },

  mixins: [
    generalMixin
  ],

  props: {
    items: {
      type: Array,
      default () {
        return []
      },
      required: true
    },
    page: {
      type: Number,
      default: 1,
      required: true
    },
    pages: {
      type: Number,
      default: 1,
      required: true
    }
  },

  data () {
    return {
      currentPage: 1
    }
  },

  created () {
    this.currentPage = this.page
  },

  methods: {
    buildPagerLink (page) {
      const params = this.urlGetParams(!!this.$route.params && !!this.$route.params.filter ? this.$route.params.filter : {})

      if (page > 1) {
        params.page = page
      }

      const filter = this.urlBuildParams(params)
      const url = !!filter
        ? this.localePath({ name: 'jobs-filter', params: { filter } })
        : this.localePath({ name: 'jobs' })

      return url
    }
  }
}
